<template>
  <v-dialog
      :value="$store.state.copyManuallyDialog.isVisible"
      :width="width"
      :retain-focus="false"
  >
    <v-sheet class="main">
      <v-btn
          class="close-btn"
          icon
          @click="close"
      >
        <v-icon> close </v-icon>
      </v-btn>
      <div class="message">{{ $store.state.copyManuallyDialog.message }}</div>
      <div class="content" @click="selectContent()" ref="content">{{ $store.state.copyManuallyDialog.content }}</div>
    </v-sheet>
  </v-dialog>
</template>

<script>
export default {
  props: {
    width: {
      type: String | Number,
      default: 600
    }
  },
  methods: {
    selectContent() {
      const contentEl = this.$refs.content;
      const range = document.createRange();
      range.selectNode(contentEl);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
    },
    close() {
      this.$store.state.copyManuallyDialog.isVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  color: var(--color-grey-900);
  border: 1px solid var(--color-grey-500);
  border-radius: 8px;
  padding: 1rem;
  font-size: 85%;
  word-wrap: break-word;
}
.main {
  padding: 24px 16px 24px;
  position: relative;

  .close-btn {
    position: absolute;
    top: 4px;
    right: 4px;
  }
}
.message{
  margin-bottom: 1rem;
}
</style>